import React from "react";
import usePageTitle from "./usePageTitle";
import App from "./App";

export default function AppWrapper() {
    usePageTitle();
    return <App />;
}